import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import '@alfredclub/hom-planner-theme/dist/scss/main.scss';
import 'izitoast/dist/css/iziToast.min.css';
import { Router } from 'react-router-dom';
import history from './Routes/history';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router history={history}>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
